export default function cookie(state = [], action) {
  switch (action.type) {
    case "ACEITAR_COOKIE":
      return [...state, {cookie: true}];
    default:
      return state;
  }
}
